import { useRef, useEffect } from "react";
import styles from "../AnalysisPanel/AnalysisPanel.module.css";
import {keyForMessage, ResponseChoice} from "../../api";
import DOMPurify from "dompurify";

// Converts simple Markdown syntax to HTML (same as in AnswerParser)
function convertMarkdownToHTML(markdown: string): string {
    return markdown
        .replace(/#+ (.*?)(\n|$)/g, "<h4>$1</h4>") // Convert # Header
        .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")   // Convert **bold**
        .replace(/\*(.*?)\*/g, "<i>$1</i>")       // Convert *italic*
        .replace(/`([^`]+)`/g, "<code>$1</code>") // Convert `code`
        .replace(/\n/g, "<br>");                  // Convert new lines
}

type TProps =  {
    answer: ResponseChoice;
    reasoning?: string;
}
export const ThoughtProcess = ({answer, reasoning}: TProps) => {
    const reasoningEndRef = useRef<HTMLDivElement | null>(null);
    
    // If reasoning is provided, display it with markdown
    const reasoningHtml = reasoning 
        ? DOMPurify.sanitize(convertMarkdownToHTML(reasoning))
        : null;

    // Auto-scroll to bottom when reasoning updates
    useEffect(() => {
        if (reasoning && reasoningEndRef.current) {
            reasoningEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [reasoning]);

    return (
        <div className={styles.thoughtProcess}>
            <div className={styles.thoughtProcessItem}>
            {reasoningHtml ? (
                <div>
                    <div 
                        className={styles.thoughtProcessText}
                        dangerouslySetInnerHTML={{ __html: reasoningHtml }}
                    />
                    <div ref={reasoningEndRef} />
                </div>
            ) : (
                <>
                    <div>
                        <div className={styles.thoughtProcessTitle}>
                            Search for:
                        </div>
                        <div className={styles.thoughtProcessText}>
                            {answer.question}
                        </div>
                    </div>
                    <div>
                        <div className={styles.thoughtProcessTitle}>
                            Prompt:
                        </div>
                        <div className={styles.thoughtProcessText}>
                            {answer.generated_question}
                        </div>
                    </div>
                    <div>
                        <div className={styles.thoughtProcessTitle}>
                            Conversation:
                        </div>
                        {!!answer?.message && <div className={styles.thoughtProcessText}>
                            &#123;
                            {Object.keys(answer?.message)?.reverse()?.map((key) => !!key && `'${key}': "${answer?.message[key as keyForMessage]}"`).join(', ')}
                            &#125;
                        </div>}
                    </div>
                </>
            )}
            </div>
        </div>
    )
}